import axios from "axios";

const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
const PUBLIC_BASE = `${BASE}/api/oracle/personalization`;
const ADMIN_BASE  = `${BASE}/api/adminone/personalization`;

const MEMBER_TOKEN_KEYS = [
  "carelogix_member_token",
  "oracle.auth.token",
  "oracle.session_token",
];
const ADMIN_TOKEN_KEYS = [
  "carelogix_adminone_token",  // primary — set by /app/frontend/src/api/adminOneClient.js
  "oracle.adminone.token",
  "adminone.token",
  "adminone_jwt",
];

function readToken(keys) {
  if (typeof window === "undefined") return null;
  for (const k of keys) {
    try {
      const v = window.localStorage.getItem(k);
      if (v) return v;
    } catch (_) { /* ignore */ }
  }
  return null;
}

const publicHttp = axios.create({ baseURL: PUBLIC_BASE, timeout: 25_000 });
publicHttp.interceptors.request.use((cfg) => {
  const t = readToken(MEMBER_TOKEN_KEYS);
  if (t && cfg && cfg.headers) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

const adminHttp = axios.create({ baseURL: ADMIN_BASE, timeout: 25_000 });
adminHttp.interceptors.request.use((cfg) => {
  const t = readToken(ADMIN_TOKEN_KEYS);
  if (t && cfg && cfg.headers) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const personalizationApi = {
  options:        () => publicHttp.get("/options"),
  getProfile:     () => publicHttp.get("/profile"),
  patchProfile:   (patch) => publicHttp.patch("/profile", patch || {}),
  postEvent:      (type, payload) => publicHttp.post("/event", { type, payload: payload || {} }),
  recommendations:(limit) => publicHttp.get("/recommendations", { params: limit ? { limit } : undefined }),
  chyron:         () => publicHttp.get("/chyron"),
};

export const adminPersonalizationApi = {
  overview:    () => adminHttp.get("/overview"),
  setSettings: (patch) => adminHttp.patch("/settings", patch || {}),
};

/**
 * Fire-and-forget event logger. Safe to call from anywhere — silently ignores
 * errors (guest, network failure, etc.).
 */
export function logEvent(type, payload) {
  try {
    personalizationApi.postEvent(type, payload).catch(() => {});
  } catch (_) { /* ignore */ }
}

export default { personalizationApi, adminPersonalizationApi, logEvent };
